// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__1z0bP","content":"LayoutSettings_content__3GUIQ"};